import React, { type InputHTMLAttributes } from "react";
import { FormattedMessage } from "react-intl";
import { Field } from "redux-form";
import FileUploadRenderer from "src/shared/forms/formrenderers/FileUploadRenderer";
import type IFormInputs from "src/shared/forms/inputs/IFormInputs";
import { required as Required } from "src/shared/forms/validations/Required";

export interface IListFileInputProps
  extends IFormInputs,
    InputHTMLAttributes<HTMLInputElement> {}

export default (props: IListFileInputProps) => {
  const {
    inputID,
    label = <FormattedMessage id="lists.list_file" />,
    validationDisabled,
    ...rest
  } = props;
  return (
    <Field
      name={inputID}
      label={label}
      component={FileUploadRenderer}
      validate={!validationDisabled ? [Required] : undefined}
      {...rest}
    />
  );
};
